'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.callApi = undefined;

var _utils = require('./utils');

exports.callApi = _utils.callApi;


//////////////////
// WEBPACK FOOTER
// /Users/runner/work/1/s/engage.framework/lib/index.js
// module id = 971
// module chunks = 2